(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

		/*const tSplide = document.querySelectorAll('.trusler-block--testimonials .splide');

		tSplide.forEach(sliderEl => {

			const splide = new Splide(sliderEl, {
				perPage: 1,
				perMove: 1,
				arrows: true,
				pagination: false,
				autoplay: true,				
				type: 'slide',
				rewind: true,
				gap: 'clamp(0px, 4.32vw, 70px)',
				mediaQuery: 'max',
				breakpoints: {
					1024: {
						perPage: 3,
					},
					768: {
						perPage: 2,
					},	
					560: {
						perPage: 1,
					},				
				}
			});

			splide.on( 'mounted', function () {

				// ?

			});			

			splide.mount();

		});

		const testBlocksArr = document.querySelectorAll('.trusler-block--testimonials');

		testBlocksArr.forEach(block => {

			ParcelFunctions.inViewport(block, 0.3, 0.15, 'block-in-viewport');

		});*/

	});

})(jQuery);